var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 878.63,
    height: 496.388,
    viewBox: "0 0 878.63 496.388",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69",
    transform: "translate(-520.685 -285.112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1089-1704",
    "data-name": "Path 1089",
    d: "M294.716,621.2c-19.511,14.544-25.04,40.135-25.04,40.135s26.1,2.009,45.615-12.535,25.04-40.135,25.04-40.135S314.227,606.659,294.716,621.2Z",
    transform: "translate(360 90)",
    fill: "#5f9c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1090-1705",
    "data-name": "Path 1090",
    d: "M302.844,628.032c-9.377,22.456-32.862,34.028-32.862,34.028s-8.281-24.837,1.1-47.293,32.862-34.028,32.862-34.028S312.221,605.576,302.844,628.032Z",
    transform: "translate(360 90)",
    fill: "#5f9c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1091-1706",
    "data-name": "Path 1091",
    d: "M864.187,563.114h0a194.649,194.649,0,0,1-1.633-42.2l1.633-23.307h0C855.187,515.52,857.221,539.09,864.187,563.114Z",
    transform: "translate(360 90)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_274-1707",
    "data-name": "Path 274",
    d: "M449.813,336.284s23.446,77.372,16.412,86.751,75.028-51.582,75.028-51.582-30.48-21.1-18.757-51.582Z",
    transform: "translate(482.023 122.697)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1092-1708",
    "data-name": "Path 1092",
    d: "M871.205,567.013h0a143.092,143.092,0,0,1-.786-25.116l.786-13.873h0C866.875,538.683,867.854,552.713,871.205,567.013Z",
    transform: "translate(360 90)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1093-1709",
    "data-name": "Path 1093",
    d: "M902.4,584.17v7.8a2.351,2.351,0,0,1-2.339,2.339h-3.9a.777.777,0,0,0-.78.78V659.03a2.352,2.352,0,0,1-2.339,2.339H845.476a2.341,2.341,0,0,1-2.339-2.339V595.087a.782.782,0,0,0-.78-.78h-4.679a2.341,2.341,0,0,1-2.339-2.339v-7.8a2.336,2.336,0,0,1,2.339-2.339h62.383A2.346,2.346,0,0,1,902.4,584.17Z",
    transform: "translate(360 90)",
    fill: "#4a433a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_346",
    "data-name": "Rectangle 346",
    width: 52.246,
    height: 2.339,
    transform: "translate(1203.207 685.945)",
    fill: "#5f9c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1094-1710",
    "data-name": "Path 1094",
    d: "M895.383,630.369c-17.483,7.235-35.156,7.315-53.026,0V613.888a83.274,83.274,0,0,1,53.026,0Z",
    transform: "translate(360 90)",
    fill: "#5f9c4c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_276",
    "data-name": "Ellipse 276",
    cx: 70.666,
    cy: 70.666,
    r: 70.666,
    transform: "translate(891.872 327.045)",
    fill: "#feb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1095-1711",
    "data-name": "Path 1095",
    d: "M754.52,489.43c-2.43-14.619-4.936-29.519-11.731-42.689-4.466-8.626-11.554-16.847-21.11-18.552a20.421,20.421,0,0,1-5.5-1.272c-2.8-1.349-40.425-22.827-46.405-26.568-5.135-3.212-13.24-9.158-17.327-9.158-4.112-.09-19.878,3.579-81.414-1.231,0,0-16.9,6.663-29.985,14.743-.2-.131-63.869,34.06-66.261,33.97-4.53-.191-8.741,2.71-11.338,6.362s-3.814,8.174-5.089,12.546c13.907,30.97,26.631,61.98,40.539,92.95a7.931,7.931,0,0,1,1.006,3.815,9.309,9.309,0,0,1-1.73,3.815c-6.82,10.956-6.6,24.736-5.858,37.613s1.668,26.478-4.087,38.02c-1.565,3.169-3.6,6.069-5.089,9.238-3.486,7.177-4.746,30.131-2.71,37.842l255.121,7.309C730.068,673.1,754.52,489.43,754.52,489.43Z",
    transform: "translate(360 90)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1421-1712",
    "data-name": "Path 1421",
    d: "M436.31,551.9a45.045,45.045,0,0,0-.153,11.109l3.656,52.513c.343,4.949.681,9.887,1.146,14.824.877,9.581,2.188,19.086,3.815,28.578a5.09,5.09,0,0,0,5.216,4.949c16.1,3.406,32.726,3.27,49.153,2.342,25.067-1.4,89.2-4.046,93.116-9.136s1.635-13.322-3.474-17.438-89.739-14.149-89.739-14.149c.827-6.553,3.321-12.724,5.688-18.946,4.25-11.035,8.22-22.432,8.3-34.253s-4.377-24.25-14.061-31.022c-7.966-5.56-18.221-6.591-27.928-6.362-7.062.2-19.265-1.489-25.716,1.272C440.223,538.431,437.264,546.9,436.31,551.9Z",
    transform: "translate(360 90)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1430-1713",
    "data-name": "Path 1430",
    d: "M457.627,458.523a13.169,13.169,0,0,0-2.824,4.518,213.588,213.588,0,0,0-17.941,73.316,7.329,7.329,0,0,1-.827,3.55,15.535,15.535,0,0,1-1.87,2.023,7.024,7.024,0,0,0,.84,9.9q.173.146.356.281c2.1-3.951,7.125-5.242,11.592-5.586,21.389-1.692,42.282,8.259,63.734,7.508-1.514-5.23-3.691-10.256-4.925-15.548-5.459-23.5,8.156-49.089-.191-71.726-1.668-4.53-4.453-8.983-8.843-10.968a23.554,23.554,0,0,0-5.662-1.5c-5.421-.979-16.212-5.166-21.453-3.486-1.935.624-2.7,2.443-4.3,3.542C462.877,455.9,459.646,456.474,457.627,458.523Z",
    transform: "translate(360 90)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1421-2-1714",
    "data-name": "Path 1421",
    d: "M754.672,536.183c-6.451-2.762-18.653-1.069-25.716-1.272-9.707-.229-19.962.8-27.928,6.362-9.684,6.772-14.137,19.2-14.061,31.022s4.046,23.218,8.3,34.253c2.366,6.222,4.861,12.393,5.688,18.946,0,0-84.63,10.034-89.739,14.149s-7.392,12.348-3.474,17.438,126.173,10.2,142.269,6.794a5.09,5.09,0,0,0,5.216-4.949c1.627-9.491,2.937-19,3.815-28.578.465-4.937.8-9.874,1.146-14.824l3.657-52.513a45.045,45.045,0,0,0-.153-11.109C762.736,546.9,759.777,538.431,754.672,536.183Z",
    transform: "translate(360 90)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1430-2-1715",
    "data-name": "Path 1430",
    d: "M734.687,454.346c-1.6-1.1-2.366-2.918-4.3-3.542-5.241-1.68-16.032,2.507-21.453,3.486a23.554,23.554,0,0,0-5.662,1.5c-4.389,1.985-7.175,6.438-8.843,10.968-8.347,22.637,5.268,48.224-.191,71.726-1.234,5.293-3.411,10.318-4.925,15.548,21.453.751,42.346-9.2,63.734-7.508,4.467.343,9.493,1.635,11.592,5.586q.183-.135.356-.281a7.024,7.024,0,0,0,.84-9.9,15.53,15.53,0,0,1-1.87-2.023,7.329,7.329,0,0,1-.827-3.55A213.586,213.586,0,0,0,745.2,463.041a13.169,13.169,0,0,0-2.824-4.518C740.354,456.474,737.123,455.9,734.687,454.346Z",
    transform: "translate(360 90)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_188",
    "data-name": "Ellipse 188",
    cx: 19.073,
    cy: 19.073,
    r: 19.073,
    transform: "translate(922.536 718.237)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_189",
    "data-name": "Ellipse 189",
    cx: 19.073,
    cy: 19.073,
    r: 19.073,
    transform: "translate(964.768 718.237)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1096-1716",
    "data-name": "Path 1096",
    d: "M741.572,690.288H479.542A11.552,11.552,0,0,1,468,678.75V519.783a11.552,11.552,0,0,1,11.539-11.539H741.572a11.552,11.552,0,0,1,11.539,11.539V678.75a11.552,11.552,0,0,1-11.539,11.539Z",
    transform: "translate(360 90)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_263",
    "data-name": "Ellipse 263",
    cx: 7.635,
    cy: 7.635,
    r: 7.635,
    transform: "translate(962.287 681.632)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1097-1717",
    "data-name": "Path 1097",
    d: "M878.63,449.724H0v27H51.97V483H826.68v-6.276h51.95Z",
    transform: "translate(520.685 298.5)",
    fill: "#3b3a3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_983-1718",
    "data-name": "Path 983",
    d: "M351.107,331.2l-11.517-4.608s24.105-26.533,57.632-24.227l-9.432-10.383s23.052-9.229,44.011,15c11.017,12.735,23.763,27.706,31.717,44.567h12.345l-5.151,11.345,18.031,11.345-18.508-2.03a62.776,62.776,0,0,1-1.751,29.381l.508,8.967s-21.464-33.212-21.464-37.82v11.538S436,373.882,436,366.96l-6.288,8.077-3.144-12.687L387.8,375.036l6.283-10.388-24.105,3.461,9.431-12.687s-27.244,15-28.292,27.688-14.669,28.84-14.669,28.84l-6.288-11.537S320.729,348.5,351.107,331.2Z",
    transform: "translate(560.596 -5.14)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1098-1719",
    "data-name": "Path 1098",
    d: "M537.556,334.049h0C526.2,334.049,517,324.1,517,311.82h0V300.7c0-12.277,9.2-22.229,20.559-22.229h0Z",
    transform: "translate(360 90)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1099-1720",
    "data-name": "Path 1099",
    d: "M668.779,278.476h0c11.355,0,20.559,9.952,20.559,22.229V311.82c0,12.277-9.2,22.229-20.559,22.229h0Z",
    transform: "translate(360 90)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1100-1721",
    "data-name": "Path 1100",
    d: "M679.553,302.452h-3.262c0-44.73-33.656-81.121-75.026-81.121s-75.026,36.391-75.026,81.121h-3.262c0-46.675,35.12-84.648,78.288-84.648S679.553,255.777,679.553,302.452Z",
    transform: "translate(360 90)",
    fill: "#6c63ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImage);
export default __webpack_public_path__ + "static/media/default_image.d25ade6d789cd54f90e13b7ea3bc2a41.svg";
export { ForwardRef as ReactComponent };